// Landing hero: the pitch and the two CTAs beside a checkout preview, four key
// numbers and the main coins.

import CheckoutMock from "@/components/Home/CheckoutMock";

const STATS = [
  { value: "30+", label: "cryptocurrencies" },
  { value: "from 0.5%", label: "processing fee" },
  { value: "5 min", label: "to first invoice" },
  { value: "15", label: "blockchain networks" },
];

const COINS = [
  { icon: "/Images/landing/coin-btc.svg", name: "BTC" },
  { icon: "/Images/landing/coin-eth.svg", name: "ETH" },
  { icon: "/Images/landing/coin-usdt.svg", name: "USDT" },
  { icon: "/Images/landing/coin-usdc.svg", name: "USDC" },
  { icon: "/Images/landing/coin-monero.svg", name: "XMR" },
  { icon: "/Images/landing/coin-ltc.svg", name: "LTC" },
  { icon: "/Images/landing/coin-sol.svg", name: "SOL" },
  { icon: "/Images/landing/coin-bnb.svg", name: "BNB" },
  { icon: "/Images/landing/coin-ton.svg", name: "GRAM" },
];

export default function Hero() {
  return (
    <section className="relative px-6 pt-[130px] md:pt-[170px] pb-16 md:pb-24 mb-20 md:mb-32 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none [background-image:linear-gradient(rgba(255,255,255,0.025)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.025)_1px,transparent_1px)] [background-size:64px_64px] [mask-image:radial-gradient(ellipse_at_top,black_20%,transparent_70%)]" />
      <div className="absolute top-[-120px] right-[-120px] w-[700px] h-[700px] rounded-full bg-[rgba(0,121,236,0.16)] blur-[160px] pointer-events-none" />

      <div className="relative max-w-[1198px] mx-auto lg:px-6 flex flex-col gap-8">
        <div className="grid lg:grid-cols-[minmax(0,1fr)_400px] gap-12 lg:gap-16 items-center">
          <div className="flex flex-col gap-8">
            <h1
              className="text-[44px] sm:text-6xl lg:text-[64px] font-medium leading-[0.98] tracking-[-0.03em] max-w-[880px]"
              style={{
                background: "linear-gradient(90deg, #E7F0F8 0%, #E7F0F8 55%, #77BDFF 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Accept crypto,
              <br />
              even from customers
              <br />
              who have none.
            </h1>
            <p className="text-[#aac4dc] text-base md:text-xl leading-relaxed max-w-[620px]">
              Let customers pay the way they can — 30+ coins or a bank card — and get stablecoins
              either way, through one integration.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
              <a
                href="/auth"
                className="inline-flex items-center justify-center gap-2.5 bg-[#0079ec] text-white text-base font-medium px-6 h-[52px] rounded-xl shadow-[0_0_40px_rgba(0,121,236,0.35)] hover:bg-[#0069d0] transition-colors"
              >
                Start accepting payments
                <svg className="w-[18px] h-[18px]" viewBox="0 0 20 19" fill="none" aria-hidden="true">
                  <path
                    d="M13.149 3.717L11.87 5.096 14.834 8.261 2.5 8.274 2.502 10.218 14.803 10.206 11.888 13.346 13.173 14.717 18.29 9.204z"
                    fill="currentColor"
                  />
                </svg>
              </a>
              <a
                href="https://docs.pawpayments.com"
                target="_blank"
                rel="noopener"
                className="inline-flex items-center justify-center text-white/80 text-base font-medium px-6 h-[52px] rounded-xl border border-white/10 hover:bg-white/5 transition-colors"
              >
                Read the docs
              </a>
            </div>
          </div>
          <CheckoutMock />
        </div>

        <div className="mt-6 grid grid-cols-2 md:grid-cols-4 border-t border-white/[0.08]">
          {STATS.map((s, i) => (
            <div key={s.label} className={`pt-6 pb-2 pr-6 ${i > 0 ? "md:border-l md:border-white/[0.08] md:pl-6" : ""}`}>
              <div className="text-white text-3xl md:text-[40px] font-medium tracking-[-0.02em]">{s.value}</div>
              <div className="mt-1 text-sm text-white/45">{s.label}</div>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap items-center gap-3">
          {COINS.map((c) => (
            <span
              key={c.name}
              className="inline-flex items-center gap-2 rounded-full border border-white/[0.07] bg-white/[0.03] pl-1.5 pr-3 py-1.5 text-[13px] text-white/70"
            >
              <img src={c.icon} alt="" width={20} height={20} decoding="async" className="w-5 h-5" />
              {c.name}
            </span>
          ))}
          <span className="text-[13px] text-white/40">and more</span>
        </div>
      </div>
    </section>
  );
}
